import { render, staticRenderFns } from "./admin-company-overview.vue?vue&type=template&id=60338afe&scoped=true&"
import script from "./admin-company-overview.ts?vue&type=script&lang=ts&"
export * from "./admin-company-overview.ts?vue&type=script&lang=ts&"
import style0 from "./admin-company-overview.vue?vue&type=style&index=0&id=60338afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60338afe",
  null
  
)

export default component.exports